import React from 'react';
import './Copies.scss';
import pfizerLogo from '../../assets/pfizer-logo.png';
import eczemaInsideOut from '../../assets/eczema-inside-out.png';

function Copy6() {
  return (
    <section className="copies marginTopAdd">
      <h4 className="copies__title title">DERMATOLOGIST SPEED-DATING</h4>
      <p className="copies__copy">
        People suffering from eczema will often see multiple dermatologists before finding someone
        who can treat them effectively. “We've had studies to show that African-Americans in
        particular, by the time they see the dermatologist that they stick with, they've seen seven
        previously,” Dr. Rice says.<sup className="copies__copy--sup">8</sup> Anne Marre says she’s
        had to hunt for a dermatologist as well, and compares it to dating, meeting different people
        before you find a good match.
      </p>
      <p className="copies__copy">
        “The real challenge is finding the right doctor for you,” Anne Marre says, one that is
        representative of her own skin tone. According to statistics, finding a dermatologist with
        skin of color, or from a particular race or ethnicity, is easier said than done. Dermatology
        has typically been one of the least diverse specialties in medicine in terms of its
        physicians.<sup className="copies__copy--sup">18</sup> Just 3% of all U.S. dermatologists
        are Black and just over 4% are Latino, compared with 12.8% Black and 16.3% Latino
        individuals in the U.S. population.
        <sup className="copies__copy--sup">18</sup>
      </p>

      <h4 className="copies__title title">THE FUTURE OF ECZEMA DIAGNOSIS</h4>
      <p className="copies__copy">
        There is much work to be done, but the dermatology field is adding more images of patients
        with greater diversity of skin color to medical literature and textbooks all the time.
        Leaders in the field like Dr. Rice are working to address racial inequality and inequity.
        Patient advocacy groups like the one started by Ellen, and individual patients like Anne
        Marre are raising awareness on social media platforms.
      </p>
      <p className="copies__copy">
        Beyond this, medical organizations, including the Skin of Color Society (SOCS), the British
        Association of Dermatologists (BAD), and the American Academy of Dermatology (AAD), are
        promoting greater diversity, equity and inclusion among dermatologists and striving for more
        equitable care for patients of all skin tones. And that should make us all feel better in
        our own skin.
      </p>
      <p className="copies__copy copies__copy--footer">
        To learn more about atopic dermatitis and how to have an informed discussion with your
        doctor,{' '}
        <a
          className="copies__link"
          href="https://www.pfizer.com/news/press-kits/eczema-press-kit"
          target="_blank"
          rel="sponsored"
        >
          click here
        </a>
        .
      </p>
      <div className="copies__logos">
        <img className="copies__logos--pfizer" alt="Pfizer logo" src={pfizerLogo} />
        <div className="copies__logos--divider" />
        <img className="copies__logos--eczema" alt="Eczema Inside Out Logo" src={eczemaInsideOut} />
      </div>
    </section>
  );
}

export default Copy6;
